// extracted by mini-css-extract-plugin
export var divider = "_1b-0";
export var dividerText = "_1b-1";